(ns app.domain.application.model
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.util :as du]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.util.util :as util]))


(def application-states
  [:state.application/appealed
   :state.application/approved
   :state.application/approved-in-principle
   :state.application/deferred
   :state.application/archived
   :state.application/changes-requested
   :state.application/complete
   :state.application/denied
   :state.application/draft
   :state.application/draft-approval
   :state.application/draft-approval-review
   :state.application/pre-con-expired
   :state.application/finished
   :state.application/in-approval
   :state.application/in-circulation
   :state.application/in-review
   :state.application/in-upper-tier-approval
   :state.application/license-fee-payment
   :state.application/license-issued
   :state.application/permit-fee-payment
   :state.application/permit-issued
   :state.application/permit-sign-off
   :state.application/pre-complete-payment
   :state.application/pre-submit-payment
   :state.application/re-issue
   :state.application/re-issue-permit
   :state.application/re-issue-permit-sign-off
   :state.application/ready-to-issue
   :state.application/refused
   :state.application/registration-fee-payment
   :state.application/registration-issued
   :state.application/rejected
   :state.application/submission-awaiting-sign-off
   :state.application/submission-changes-requested
   :state.application/submitted
   :state.application/withdrawal-requested
   :state.application/withdrawn])


(defn external-id [application]
  (-> application :entity/parent :workspace/external-id))


(defn workspace [application]
  (-> application :entity/parent))


(defn workspace-id [application]
  (-> application workspace :workspace/id))


(defn permit-type [application]
  (-> application workspace :workspace/permit-type))


(defn sign-off-form [application]
  (-> application :application/sign-off-form))


(defn sign-off-pdf [application]
  (du/find-descendant {:file/category :file.category/sign-off-form} application))


(def initial-domain-state :state.application/draft)


(def initial-process-state :process.state/draft)

(defmethod group-model/get-authority-group :entity.type/application
  [app]
  (-> app :entity/parent group-model/get-authority-group))

(defmethod group-model/get-authority-group :entity.type/pre-consultation
  [pre-consultation]
  (-> pre-consultation :entity/parent group-model/get-authority-group))

(defn single-work-type
  "Get a single work type for an application that is not expected to have more"
  [application]
  {:pre [(->> application
              :entity/parent
              :workspace/permit-type
              (contains? ptc-model/permit-types-with-multiple-work-types)
              not)]}
  (let [[wt & more] (:application/work-type-group-configs application)]
    (when more
      (let [permit-type (-> application :entity/parent :workspace/permit-type)]
        (throw (ex-info (str "multiple work-types for " permit-type " application")
                        (util/mmap permit-type)))))
    wt))

(defn work-set-prevented? [application]
  (let [workspace            (-> application :entity/parent)
        work-defaults-config (:workspace/category-group-config workspace)]
    (and (config-model/default-work-set? work-defaults-config)
         (:group.config/default-change-prevented? work-defaults-config)
         (->> application
              ;; this is fine, because the config is never allowed for multi-work-type
              single-work-type
              (= (:group.config/default-work-type-gc work-defaults-config)))
         (-> application
             :application/work-target-group-config
             (= (:group.config/default-work-target-gc work-defaults-config))))))

(defn work-type-name [application lang]
  (some->> application
           :application/work-type-group-configs
           seq
           (map #(config-model/localized-name % lang))
           sort
           (str/join ", ")))

(defn work-type-names [application lang]
  (->> application
       :application/work-type-group-configs
       (map (comp #(i18n-model/get-text % lang) :group.config/names))
       sort))

(defn work-target-name [application lang]
  (some-> application
          :application/work-target-group-config
          (config-model/localized-name lang)))

(def process-flows-with-deem-complete
  (->> ["ca" "us"]
       (mapcat (fn [country]
                 [[country :permit-type/P nil] ;; nil for default, because at permit-type level config
                  ;; there is nother specified for process-flow and no easy
                  ;; way to e.g. :process-flow/default-P
                  [country :permit-type/P :process-flow/default-P] ;; default-P is also needed, because it may
                  ;; be set at category level
                  [country :permit-type/P :process-flow/pre-submission]
                  [country :permit-type/P :process-flow/site-plan]
                  [country :permit-type/P :process-flow/planning-with-agreement]
                  [country :permit-type/P :process-flow/condominium-conversion]
                  [country :permit-type/P :process-flow/municipal-addressing]
                  [country :permit-type/P :process-flow/plan-amendment]
                  [country :permit-type/P :process-flow/approval-council-notice-upload]]))
       ;; US Planning is only offered in the US, see group-model/process-flow-countries
       (cons ["us" :permit-type/P :process-flow/us-planning])
       set))
